import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCursos = async (pagina, palabraBuscada,convocatoria,urlSubcat) => {
  try {
    const response = await axios.post(`${API_URL}/api/cursos/filters`, {
      current_page: pagina || 1,
      items_per_page: 10,
      filteredWord: palabraBuscada || '',
      convocatoria: convocatoria,
      subcategoria: urlSubcat,
      activo: "1",
      visible: true
    });

    return response.data;
  } catch (error) {
    console.log("Ha habido un error:", error);
    throw error;
  }
};


export const fetchCursosOcupados= async (pagina, palabraBuscada,urlSubcat) => {
    try {
      const response = await axios.post(`${API_URL}/api/cursos/filters`, {
        current_page: pagina || 1,
        items_per_page: 10,
        filteredWord: palabraBuscada,
        convocatoria: "ocupados",
        subcategoriaCurso: `/` + urlSubcat,
      });
  
      return response.data;
    } catch (error) {
      console.log("Ha habido un error:", error);
      throw error;
    }
  };
